import { http } from '../http';
import { extrairMensagemErro } from '../../utils/apiError';

export interface CotacaoData {
  nome: string;
  email: string;
  celular: string;
  cpf: string;
  placa: string;
  marca: string;
  modelo: string;
  ano: number;
  cotaParticipacao?: string;
}

export interface UpdateCotacaoData {
  id: string;
  nome?: string;
  email?: string;
  celular?: string;
  cpf?: string;
  placa?: string;
  marca?: string;
  modelo?: string;
  ano?: number;
  cotaParticipacao?: string;
  produtos?: string[];
}

export interface CalcularCotaInput {
  porcentagem_fipe: number;
  valor_fipe: number;
}

export interface CalcularCotaResponse {
  valor_cota_participacao: number;
  porcentagem_fipe: number;
}

export const criarCotacao = async (dados: CotacaoData): Promise<any> => {
  try {
    const response = await http.post('/cotacoes', dados);

    return response.data;
  } catch (error: any) {
    throw new Error(extrairMensagemErro(error, 'Erro ao criar cotação'));
  }
};

export const editarCotacao = async (dados: UpdateCotacaoData): Promise<any> => {
  try {
    const { id, ...body } = dados;

    const response = await http.patch(`/cotacoes/${id}`, body);

    return response.data;
  } catch (error: any) {
    throw new Error(extrairMensagemErro(error, 'Erro ao editar cotação'));
  }
};

export const calcularCotaParticipacao = async (
  dados: CalcularCotaInput
): Promise<CalcularCotaResponse> => {
  try {
    const response = await http.post('/cotacoes/calcular-cota', dados);

    return response.data;
  } catch (error: any) {
    throw new Error(extrairMensagemErro(error, 'Erro ao calcular cota de participação'));
  }
};
